import type { SVGProps } from "react";
export interface PlaneDepartureIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneDepartureIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneDepartureIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m22 19.875.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H2a1.125 1.125 0 0 1 0-2.25zM5.965 4.311a3.13 3.13 0 0 1 3.25.034l5.187 3.233 2.165-1.01c.863-.402 2.028-.798 3.139-.853 1.094-.055 2.503.233 3.16 1.642.656 1.408-.029 2.67-.774 3.474-.756.816-1.808 1.454-2.672 1.856l-8.487 3.957a5.1 5.1 0 0 1-2.165.48H5.054c-.64 0-1.241-.288-1.642-.776l-.16-.221L1.12 12.72a1.625 1.625 0 0 1 .706-2.342l.715-.324.193-.08a3.13 3.13 0 0 1 2.928.393l1.08.781 1.4-.653-3.076-3.31a1.625 1.625 0 0 1 .258-2.437l.445-.312zm2.06 1.943a.87.87 0 0 0-.807-.059l3.158 3.4.129.157c.586.81.303 1.984-.633 2.421l-2.51 1.17a1.63 1.63 0 0 1-1.64-.155l-1.378-.996a.87.87 0 0 0-.765-.129l-.108.041-.065.028 1.717 2.742h3.645c.42 0 .834-.092 1.214-.27l8.487-3.957c.723-.337 1.49-.824 1.973-1.345.494-.532.467-.817.384-.995-.082-.177-.284-.381-1.009-.345-.71.035-1.576.309-2.298.646l-2.474 1.154a1.63 1.63 0 0 1-1.367.003l-.18-.097z"
      />
    </svg>
  );
}
